import {  createTheme } from '@mui/material/styles';
import { FONT_FAMILY } from 'common/sharedFunctions';
import adminTokens from './adminDesignTokens';

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          borderBottom: `1px solid ${adminTokens.colors.border}`,
          color: adminTokens.colors.text,
          fontSize: '0.78rem',
          lineHeight: 1.28,
          padding: adminTokens.density.tableCellPadding,
        },
        head: {
          backgroundColor: '#F7FBFF',
          color: adminTokens.colors.deepNavy,
          fontWeight: 850,
          fontSize: '0.72rem',
          letterSpacing: '0.01em',
          whiteSpace: 'nowrap',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          borderRadius: adminTokens.radius.lg,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          transition: 'background 160ms cubic-bezier(.2,.8,.2,1)',
          '&:hover': {
            backgroundColor: 'rgba(11, 124, 255, 0.045)',
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 800,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          minHeight: adminTokens.density.tableRowHeight,
          borderRadius: adminTokens.radius.md,
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          color: adminTokens.colors.muted,
          fontSize: adminTokens.density.fontBody,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          minHeight: adminTokens.density.controlHeight,
          fontSize: '0.78rem',
          textTransform: 'none',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          minHeight: adminTokens.density.controlHeight,
          fontSize: '0.8rem',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          width: 32,
          height: 32,
          padding: 5,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.76rem',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.76rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          minHeight: 34,
          fontSize: '0.8rem',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.8rem',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.8rem',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.75rem',
          minHeight: 42,
        },
        selectLabel: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.75rem',
        },
        displayedRows: {
          fontFamily: FONT_FAMILY,
          fontSize: '0.75rem',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
    
  
  },
});

export default theme;
